import React from 'react';
import { VARIABLE_TYPE_CHOICES } from '../../../utils/variableTypeChange';

/**
 * Text / Number / Array rows for "{{" create and linked-row create.
 */
export const VariableTypeChoices = ({
  name,
  selectedIndex = 0,
  onChoose,
  onHover,
  itemClassName = 'doc-slash-item',
  selectedClassName = 'selected',
}) => (
  <>
    <div className="doc-slash-empty doc-variable-picker__type-title">
      Create “{name}” as
    </div>
    {VARIABLE_TYPE_CHOICES.map((choice, index) => (
      <div
        key={choice.type}
        className={`${itemClassName} ${index === selectedIndex ? selectedClassName : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          onChoose?.(choice.type);
        }}
        onMouseEnter={() => onHover?.(index)}
      >
        <span className="doc-slash-label">{choice.label}</span>
        <span className="doc-slash-description">· {choice.hint}</span>
      </div>
    ))}
  </>
);
